import { useLang } from "@/lib/i18n";

const COLORS = {
  awaiting_payment: "bg-slate-500/20 text-slate-300",
  paid: "bg-gold/20 text-gold",
  sent_to_ton_atelier: "bg-fire/20 text-fire",
  in_production: "bg-smoke/30 text-purple-300",
  shipped: "bg-cap/25 text-sky-300",
  delivered: "bg-emerald-500/20 text-emerald-300",
  cancelled: "bg-ruby/20 text-ruby",
};

export const StatusBadge = ({ status, testid }) => {
  const { t } = useLang();
  return <span className={`inline-block whitespace-nowrap rounded px-2 py-0.5 text-xs font-extrabold ${COLORS[status] || ""}`} data-testid={testid}>{t(`admin_status.${status}`)}</span>;
};
